import React from 'react';
import { Dropdown } from 'semantic-ui-react';

export function driverPicker(users){
    let drivers = [];
    let loading = false;
    if(users ){
        for(var i = 0; i< users.length; i++){
            drivers.push({key:users[i].Id, text: users[i].LicenceNo+' - '+users[i].Name+' '+users[i].Surname ,value: users[i].Id});
        }
    }
    else if(!users && this.props.driversLoading){
        loading =true;
    }
    return (
        <Dropdown 
            id='Egitimler-top' placeholder='Suruculer' options={drivers} 
            search
            style={{width: '60%'}}
            fluid 
            selection 
            loading = {loading}
            onChange={this.ChangeTabs.bind(this)} 
        />
    );
}



// WEBPACK FOOTER //
// ./src/components/PanelPages/driverPicker.jsx